import keyStore, { sessionKey } from 'Store/keyStore'

const session = {
    set: function (token: string) {
        try {
            const encode = window.btoa(token);
            localStorage.setItem(keyStore.USER_TOKEN, encode);
        } catch(error) {
            console.info(error)
        }
    },
    has: function () {
        try {
            var user = localStorage.getItem(keyStore.USER_TOKEN);
            return !!user;
        } catch {
            return false;
        }
    },
    get: function () {
        try {
            const user = localStorage.getItem(keyStore.USER_TOKEN);
            if (user) {
                const decode = window.atob(user);
                return JSON.parse(decode);
            }
            return '';
        } catch(error) {
            localStorage.removeItem(keyStore.USER_TOKEN);
            return '';
        }
    },
    remove: function () {
        localStorage.removeItem(keyStore.USER_TOKEN);
    }
}

export default session;

export const userSessionProfile = {
    set: function (token: string) {
        localStorage.setItem(sessionKey.USER_PROFILE, token);
    },
    has: function () {
        var user = localStorage.getItem(sessionKey.USER_PROFILE);
        return !!user;
    },
    get: function () {
        const user = localStorage.getItem(sessionKey.USER_PROFILE);
        return !!user ? JSON.parse(user) : "";
    },
    remove: function () {
        localStorage.removeItem(sessionKey.USER_PROFILE);
    }
}